module.exports = __webpack_public_path__ + "img/logo-pure-white.230547ae.svg";